import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutpaint = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-square-dashed-mouse-pointer-icon lucide-square-dashed-mouse-pointer",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 3a2 2 0 0 0-2 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 3a2 2 0 0 1 2 2" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 21a2 2 0 0 1-2-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 3h1" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 21h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 3h1" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 9v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 9v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 14v1" })
	]
});
export default SvgOutpaint;
